/* Ravule PDP — vanilla gallery, BOGO bundle builder, AJAX add-to-cart, countdown.
   No third-party libraries. Reuses Dawn's cart drawer + pubsub for cart updates. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ws-pdp]');
  if (!root) return;

  /* ---------- first-screen warm ----------
     The click → cart-drawer-open floor is one server-rendered POST /cart/add.js(sections=cart-drawer),
     and that render is dominated by the "Frequently bought together" product-recommendations query.
     On idle (after the PDP is painted) we PRE-WARM that work so it is cached before the shopper clicks:
       1. prime this product's recommendations (it will be the cart item after ATC), and
       2. render the cart-drawer section once so its Liquid/snippets/edge cache are warm.
     Best-effort, off the critical path, failures ignored — no functional side effects (both are GETs). */
  (function warmCartDrawer() {
    function warm() {
      try {
        var pid = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.id;
        if (pid) {
          fetch('/recommendations/products?product_id=' + pid + '&limit=10&intent=complementary', { headers: { 'Accept': 'text/html' } }).catch(function () {});
        }
        fetch(location.pathname + '?sections=cart-drawer', { headers: { 'Accept': 'application/json' } }).catch(function () {});
      } catch (e) {}
    }
    if ('requestIdleCallback' in window) { requestIdleCallback(warm, { timeout: 2500 }); }
    else { setTimeout(warm, 1200); }
  })();

  var data = {};
  var dataEl = root.querySelector('[data-ws-variant-data]');
  if (dataEl) { try { data = JSON.parse(dataEl.textContent); } catch (e) {} }
  var variants = data.variants || [];
  var colors = data.colors || [];
  var sizes = data.sizes || [];
  var colorIdx = (data.options && data.options.color ? data.options.color : 1) - 1;
  var sizeIdx = (data.options && data.options.size ? data.options.size : 2) - 1;
  var hasColor = colors.length > 0;
  var hasSize = sizes.length > 0;
  var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

  function money(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var ph = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var m = moneyFormat.match(ph);
    var val = '';
    switch (m ? m[1] : 'amount') {
      case 'amount': val = fmt(cents, 2); break;
      case 'amount_no_decimals': val = fmt(cents, 0); break;
      case 'amount_with_comma_separator': val = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': val = fmt(cents, 0, ' '); break;
      case 'amount_with_space_separator': val = fmt(cents, 2, ' ', ','); break;
      default: val = fmt(cents, 2);
    }
    return moneyFormat.replace(ph, val);
  }
  function findVariant(color, size) {
    return variants.find(function (v) {
      var okC = !hasColor || v.options[colorIdx] === color;
      var okS = !hasSize || v.options[sizeIdx] === size;
      return okC && okS;
    });
  }
  function colorHex(name) {
    var map = { black: '#2b2b2b', white: '#f1efe9', gray: '#9a9a9a', grey: '#9a9a9a', beige: '#d8c4a8', pink: '#e7b7b0', blush: '#e3b9b3', stone: '#b8ad9c', sand: '#d8c19a', olive: '#7e7d52', sage: '#9bab8e', cream: '#ece6d6', brown: '#6b4f3a', navy: '#2e3a52', charcoal: '#3a3d42', tan: '#c9a87c', sky: '#a9c5dd', rose: '#c9a0a0', blue: '#3f6090' };
    return map[(name || '').toLowerCase().trim()] || '#cdd2cf';
  }
  function colorImage(name) {
    var v = variants.find(function (vv) { return vv.image && (!hasColor || vv.options[colorIdx] === name); });
    return v ? v.image : null;
  }

  /* ---------- gallery ---------- */
  (function () {
    var g = root.querySelector('[data-ws-gallery]'); if (!g) return;
    var main = g.querySelector('[data-gallery-main]');
    var slides = main ? main.children : [];
    var thumbs = g.querySelectorAll('[data-thumb]');
    var idx = 0;
    function go(i) {
      if (!slides.length) return;
      idx = Math.max(0, Math.min(i, slides.length - 1));
      main.scrollTo({ left: slides[idx].offsetLeft - main.offsetLeft, behavior: 'smooth' });
      markActive(idx);
    }
    var dots = g.querySelectorAll('[data-dot]');
    function markActive(n) {
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === n); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === n); });
    }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-dot'), 10)); }); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-thumb'), 10)); }); });
    if (main) {
      var raf;
      main.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var c = main.scrollLeft + main.offsetWidth / 2, best = 0, bd = Infinity;
          [].forEach.call(slides, function (s, n) { var d = Math.abs(s.offsetLeft - main.offsetLeft + s.offsetWidth / 2 - c); if (d < bd) { bd = d; best = n; } });
          idx = best; markActive(best);
        });
      }, { passive: true });
    }
    /* expose for variant→image */
    root._galleryToMedia = function (mediaId) {
      var n = -1;
      [].forEach.call(slides, function (s, i) { if (s.getAttribute('data-media-id') == mediaId) n = i; });
      if (n >= 0) go(n);
    };
  })();

  /* ---------- bundle builder ---------- */
  var bundle = root.querySelector('[data-ws-bundle]');
  var atcBtn = root.querySelector('[data-ws-atc]');
  var atcPrice = root.querySelector('[data-atc-price]');
  var atcText = root.querySelector('[data-atc-text]');
  var atcError = root.querySelector('[data-atc-error]');
  var selectedOffer = null;

  function buildPair(offerCard, pairIdx, isFree) {
    var wrap = document.createElement('div');
    wrap.className = 'custom-bundle__item' + (isFree ? ' custom-bundle__item--free' : '');
    var uid = offerCard.dataset.idx + '-' + pairIdx;
    var head = '<div class="custom-bundle__item-head"><span class="custom-bundle__item-title">' + (pairIdx + 1) + '. Select Your ' + (isFree ? 'Free ' : '') + 'Pair</span>' + (isFree ? '<span class="custom-bundle__item-free">Free</span>' : '') + '</div>';
    var defColor = null;
    if (hasColor) {
      for (var di = 0; di < colors.length; di++) { if (anyAvailable(colors[di], null)) { defColor = colors[di]; break; } }
      if (defColor === null) defColor = colors[0];
    }
    var swatches = hasColor ? '<div class="custom-bundle__option custom-bundle__option--swatch"><div class="custom-bundle__values">' + colors.map(function (c, i) {
      var id = 'c-' + uid + '-' + i;
      var img = colorImage(c);
      /* F4: colorways without a variant photo get a NEUTRAL card — white bg, muted
         shoe glyph, small color dot — instead of a saturated color fill. */
      var inner = img ? '<img src="' + img + '" alt="' + c + '" loading="lazy" decoding="async">' : '<span class="cb-swatch-ph"><svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 60c2-9 6-14 12-17 3-2 5-1 7 1l6 7c2 2 5 3 8 3l16 1c6 0 10 3 11 8 1 4-2 7-7 7H26c-6 0-9-4-8-10z"/><path d="M21 64h54"/><path d="M40 51l5 5"/></svg><span class="cb-swatch-ph__dot" style="background:' + colorHex(c) + '"></span></span>';
      return '<input type="radio" class="custom-bundle__input" name="c-' + uid + '" id="' + id + '" value="' + c + '"' + (c === defColor ? ' checked' : '') + '><label class="custom-bundle__value custom-bundle__value--swatch" for="' + id + '" title="' + c + '">' + inner + '</label>';
    }).join('') + '</div></div>' : '';
    var pills = hasSize ? '<div class="custom-bundle__option custom-bundle__option--pill"><div class="custom-bundle__values">' + sizes.map(function (s, i) {
      var id = 's-' + uid + '-' + i;
      return '<input type="radio" class="custom-bundle__input" name="s-' + uid + '" id="' + id + '" value="' + s + '"><label class="custom-bundle__value" for="' + id + '"><span>' + s + '</span></label>';
    }).join('') + '</div></div>' : '';
    var summary = '<div class="custom-bundle__item-summary is-empty">Select your color and size</div>';
    wrap.innerHTML = head + swatches + pills + summary;
    refreshAvailability(wrap);
    return wrap;
  }

  /* T12: cross-check option values against variant availability for the pair's
     other selected option; disable + mark combos with no purchasable variant.
     The ATC-time error in collectItems() stays as a backstop. */
  function anyAvailable(color, size) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (!v.available) continue;
      if (color && v.options[colorIdx] !== color) continue;
      if (size && v.options[sizeIdx] !== size) continue;
      return true;
    }
    return false;
  }
  function refreshAvailability(pairEl) {
    var c = pairEl.querySelector('.custom-bundle__input[name^="c-"]:checked');
    var s = pairEl.querySelector('.custom-bundle__input[name^="s-"]:checked');
    pairEl.querySelectorAll('.custom-bundle__input[name^="s-"]').forEach(function (input) {
      var ok = anyAvailable(c ? c.value : null, input.value);
      input.disabled = !ok;
      var label = pairEl.querySelector('label[for="' + input.id + '"]');
      if (label) label.classList.toggle('is-unavailable', !ok);
      if (!ok && input.checked) input.checked = false;
    });
    /* Colors are NEVER disabled — disabling them combinatorially with the size
       filter can lock out purchasable colors. A fully sold-out color is only
       marked visually; clicking any color re-filters sizes (and the size loop
       above unchecks a size the new color can't supply). */
    pairEl.querySelectorAll('.custom-bundle__input[name^="c-"]').forEach(function (input) {
      var dead = !anyAvailable(input.value, null);
      var label = pairEl.querySelector('label[for="' + input.id + '"]');
      if (label) label.classList.toggle('is-unavailable', dead);
    });
  }

  function renderOffer(offerCard) {
    var body = offerCard.querySelector('[data-bundle-body]');
    if (!body || body.dataset.built) { return; }
    var total = parseInt(offerCard.getAttribute('data-total'), 10) || 1;
    var buy = parseInt(offerCard.getAttribute('data-buy') || total, 10);
    for (var i = 0; i < total; i++) {
      body.appendChild(buildPair(offerCard, i, i >= buy));
    }
    body.dataset.built = '1';
    /* sync gallery on colour change */
    body.addEventListener('change', function (e) {
      var item = e.target.closest('.custom-bundle__item');
      if (!item) return;
      refreshAvailability(item); /* first — may uncheck a size that just became unavailable */
      var c = item.querySelector('.custom-bundle__input[name^="c-"]:checked');
      var s = item.querySelector('.custom-bundle__input[name^="s-"]:checked');
      var sum = item.querySelector('.custom-bundle__item-summary');
      if (sum) {
        if (c && s) { sum.textContent = c.value + ' / ' + s.value; sum.classList.remove('is-empty'); }
        else { sum.textContent = 'Select your color and size'; sum.classList.add('is-empty'); }
      }
      if (c && root._galleryToMedia) { var mv = findVariant(c.value, s ? s.value : null); if (mv && mv.media_id) root._galleryToMedia(mv.media_id); }
    });
  }

  function matchPairVariant(pairEl) {
    var c = pairEl.querySelector('.custom-bundle__input[name^="c-"]:checked');
    var s = pairEl.querySelector('.custom-bundle__input[name^="s-"]:checked');
    return findVariant(c ? c.value : null, s ? s.value : null);
  }

  if (bundle) {
    var cards = bundle.querySelectorAll('[data-bundle-offer]');
    cards.forEach(function (card, i) {
      card.dataset.idx = i;
      var buyTotal = parseInt(card.getAttribute('data-total'), 10);
      card.setAttribute('data-buy', card.getAttribute('data-buy') || buyTotal);
      var radio = card.querySelector('.custom-bundle__radio');
      function select() {
        cards.forEach(function (c) { c.classList.remove('is-active'); });
        card.classList.add('is-active');
        renderOffer(card);
        selectedOffer = card;
        updateAtcPrice();
      }
      radio.addEventListener('change', function () { if (radio.checked) select(); });
      if (radio.checked) select();
    });
  } else {
    selectedOffer = null;
  }

  function updateAtcPrice() {
    if (!atcPrice) return;
    var base = variants[0] ? variants[0].price : 0;
    var buy = selectedOffer ? parseInt(selectedOffer.getAttribute('data-total'), 10) : 1;
    /* pay for the "buy" pairs only — derive from total/free via title data */
    var pay = selectedOffer ? parseInt(selectedOffer.getAttribute('data-buy'), 10) : 1;
    atcPrice.textContent = money(base * (pay || 1));
  }

  /* ---------- add to cart ---------- */
  function collectItems() {
    var items = [];
    if (!selectedOffer) {
      var v = variants.find(function (x) { return x.available; }) || variants[0];
      if (v) items.push({ id: v.id, quantity: 1 });
      return { items: items, error: null };
    }
    var pairs = selectedOffer.querySelectorAll('.custom-bundle__item');
    for (var i = 0; i < pairs.length; i++) {
      var v = matchPairVariant(pairs[i]);
      if (!v) return { items: [], error: 'Please choose a colour and size for every pair.' };
      if (!v.available) return { items: [], error: 'One of your selected pairs is sold out — please pick another.' };
      var isFree = pairs[i].classList.contains('custom-bundle__item--free');
      items.push({ id: v.id, quantity: 1, properties: isFree ? { '_bundle': 'free pair' } : { '_bundle': 'paid pair' } });
    }
    /* FREE-marked pairs go FIRST: with equal-priced tiers Shopify's automatic BxGy allocates
       the 100%-off to the first qualifying line, so ordering [free, paid] makes the cart's
       $0.00 line MATCH the pair the shopper picked under "Select Your Free Pair" (otherwise
       the badge lands on the paid pick — right total, visibly wrong pair). */
    items.sort(function (a, b) {
      var af = a.properties && a.properties['_bundle'] === 'free pair' ? 0 : 1;
      var bf = b.properties && b.properties['_bundle'] === 'free pair' ? 0 : 1;
      return af - bf;
    });
    return { items: items, error: null };
  }

  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      if (atcError) { atcError.hidden = true; atcError.textContent = ''; }
      var res = collectItems();
      if (res.error) { if (atcError) { atcError.textContent = res.error; atcError.hidden = false; } return; }
      if (!res.items.length) return;
      atcBtn.classList.add('is-loading'); atcBtn.disabled = true;
      var drawer = document.querySelector('cart-drawer');
      var body = { items: res.items };
      /* Ask Shopify to re-render the cart-drawer section so the add response carries
         `sections`, which cart-drawer.renderContents(response) requires. Passing the
         plain /cart.js object (no .sections) is what threw "reading 'cart-drawer'". */
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      /* Spinner stays on the ATC button (is-loading) while the request is in flight; the drawer
         opens only once its real contents are rendered — it is never shown blank. */
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (resp) {
        if (resp.status) { throw new Error(resp.description || resp.message || 'Could not add to cart'); }
        /* Clear the stale is-empty up-front (an add is NEVER empty) so the drawer never opens in
           Dawn's empty-state grid layout — kills the distorted-then-reflow flash the old flow had. */
        document.querySelectorAll('cart-drawer, cart-drawer-items').forEach(function (el) { el.classList.remove('is-empty'); });
        if (drawer && resp.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(resp); /* renderContents calls open() itself */
        } else if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        }
        /* Header count + cartUpdate are read from the JUST-RENDERED drawer — no second /cart.js
           round-trip. The add.js response already carried the rendered drawer HTML (sections=). */
        var cEl = document.querySelector('cart-drawer .ws-cartd__count');
        var count = cEl ? parseInt(cEl.textContent, 10) : NaN;
        if (!isNaN(count)) {
          document.querySelectorAll('[data-wsx-cart-count]').forEach(function (el) { el.textContent = count; el.classList.remove('is-empty'); });
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ws-pdp', cartData: { item_count: count } });
          }
        }
      }).catch(function (err) {
        /* The drawer was never opened optimistically, so nothing to hide on error — just surface it. */
        if (atcError) { atcError.textContent = err.message; atcError.hidden = false; }
      }).finally(function () {
        atcBtn.classList.remove('is-loading'); atcBtn.disabled = false;
      });
    });
  }

  /* ---------- countdown ---------- */
  root.querySelectorAll('[data-ws-countdown]').forEach(function (el) {
    var mins = parseInt(el.getAttribute('data-minutes'), 10) || 30;
    /* Share the countdown bar's end instant so both timers stay in sync (key 'wsOfferEnd').
       Adopt the announcement bar's own duration when it's on the page, so that even if both
       timers seed sessionStorage on the same tick (read-before-write race) they compute an
       IDENTICAL end — then prefer any already-stored end. */
    var bar = document.querySelector('.countdown-bar[data-cd-minutes]');
    if (bar) { var bm = parseInt(bar.getAttribute('data-cd-minutes'), 10); if (bm > 0) mins = bm; }
    var end;
    try {
      var stored = window.sessionStorage.getItem('wsOfferEnd');
      if (stored && parseInt(stored, 10) > Date.now()) {
        end = parseInt(stored, 10);
      } else {
        end = Date.now() + mins * 60000;
        window.sessionStorage.setItem('wsOfferEnd', String(end));
      }
    } catch (e) { end = Date.now() + mins * 60000; }
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var left = Math.max(0, end - Date.now());
      var h = Math.floor(left / 3600000), m = Math.floor((left % 3600000) / 60000), s = Math.floor((left % 60000) / 1000);
      el.textContent = (h > 0 ? pad(h) + ':' : '') + pad(m) + ':' + pad(s);
      if (left > 0) setTimeout(tick, 1000);
    }
    tick();
  });

  /* sellout toggle */
  root.querySelectorAll('[data-ws-sellout]').forEach(function (s) {
    var t = s.querySelector('.pe-sellout-risk-toggle');
    if (t) t.addEventListener('click', function () {
      var open = s.classList.toggle('active');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* Find My Size (data-sf-open) + Size Chart (#sh-tab-chart / aria-controls=sc-overlay)
     are wired page-wide by the widestep-size-tools section — no handler needed here. */

  /* ---------- sticky ATC ----------
     The sticky bar's own observer lives in sections/widestep-sticky-atc.liquid
     and anchors on [data-ws-atc]. We deliberately do NOT wire a second observer
     here — two competing IntersectionObservers toggling the same class raced and
     both no-opped. Keeping a single observer (in the section) is the fix. */

  /* ---------- ?variant deep-link preselect (Round-1 fix) ----------
     Shared/ad links land with ?variant=<id>; the bundle UI previously ignored it
     entirely (identical default state for any id). Preselect that variant's
     colour + size on the ACTIVE offer's first pair; dispatched change events run
     the normal summary/availability/price pipeline. */
  (function initVariantParam() {
    var vid = parseInt(new URLSearchParams(window.location.search).get('variant'), 10);
    if (!vid || !variants.length) return;
    var v = null;
    for (var i = 0; i < variants.length; i++) { if (variants[i].id === vid) { v = variants[i]; break; } }
    if (!v) return;
    var card = root.querySelector('[data-bundle-offer].is-active') || root.querySelector('[data-bundle-offer]');
    if (!card) return;
    var pair = card.querySelector('.custom-bundle__item');
    if (!pair) return;
    function check(prefix, value) {
      if (value == null) return;
      var inputs = pair.querySelectorAll('.custom-bundle__input[name^="' + prefix + '-"]');
      for (var k = 0; k < inputs.length; k++) {
        if (inputs[k].value === value) {
          if (!inputs[k].checked) { inputs[k].checked = true; }
          inputs[k].dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
    }
    check('c', v.options[colorIdx]);
    check('s', v.options[sizeIdx]);
  })();
})();
